import { CustomerDto, CustomersApiService, GetDataApiService, LoadingParamsUtils } from '@api';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AntDataResponse, AntSortLoadingParams } from '@antony/ng-ui';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class InactiveCustomersService implements GetDataApiService<CustomerDto> {
  constructor(private api: CustomersApiService) {}

  getData(params: Partial<AntSortLoadingParams<CustomerDto>>): Observable<AntDataResponse<CustomerDto>> {
    return this.api
      .getPagedCustomersByInactiveState(
        LoadingParamsUtils.getSkipFrom(params),
        LoadingParamsUtils.getTakeFrom(params),
        LoadingParamsUtils.getFilterNamesFrom(params),
        LoadingParamsUtils.getFilterValueFrom(params),
        LoadingParamsUtils.getSortNamesFrom(params),
        LoadingParamsUtils.getApiSortDirection(params),
        true
      )
      .pipe(
        map((res) => ({
          data: res.data || [],
          maxCount: res.maxCount || 0,
        }))
      );
  }
}
